export enum AppNamesEnum {
  PROAPP = 'PROAPP',
  RESIDEOACADEMY = 'RESIDEOACADEMY',
}
